import { render, staticRenderFns } from "./MunicipioComboboxUf.vue?vue&type=template&id=5ef1c272"
import script from "./MunicipioComboboxUf.vue?vue&type=script&lang=js"
export * from "./MunicipioComboboxUf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports